export const EVENTS = {
    DOM_CHANGE: 'dom:change',

    SEARCH_OPENED: 'search:opened',
    SEARCH_CLOSED: 'search:closed',
    SEARCH_TOGGLE: 'search:toggle',

    POPUPNAV_OPENED: 'popupnav:opened',
    POPUPNAV_CLOSED: 'popupnav:closed',
    POPUPNAV_TOGGLE: 'popupnav:toggle',
    POPUPNAV_OPEN: 'popupnav:open',
    POPUPNAV_CLOSE: 'popupnav:close',
    POPUPNAV_SETCATEGORY: 'popupnav:setcategory',
    POPUPNAV_CATEGORYCHANGED: 'popupnav:categorychanged',

    MODAL_OPEN: 'modal:open', //natvrdo v Modal.js
    MODAL_CLOSE: 'modal:close', //natvrdo v Modal.js
    MODALOPENER_CLICK: 'modalopener:click', //natvrdo v Modal.js

    FORMSIGNAL_DO: 'formsignal:do',

    SECTIONOBSERVER_SECTIONCHANGE: 'sectionobserver:sectionchange',

    TAB_CHANGE: 'tab:change',
}
